import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setTaxrate, clearTaxrateErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  taxrates: PropTypes.object,
  error: PropTypes.any,
};

class TaxrateNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        zipcode: null,
        tax: null,
      },
      taxrate: {
        name: null,
        zipcode: null,
        tax: 0,
        disabled: false,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.taxrate && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Tax Rate saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const taxrate = this.state.taxrate;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = taxrate[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.taxrate;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      taxrates: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearTaxrateErrors());
    this.props.dispatch(setTaxrate(this.state.taxrate));
  }
  handleCancel() {
    this.props.dispatch(clearTaxrateErrors());
    browserHistory.push('/taxrate?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/taxrate?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="taxrate component" style={authPage}>
        <h2>New Tax Rate</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Zipcode"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.taxrate.zipcode || ''}
              name="zipcode"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.zipcode}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.taxrate.name || ''}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
            />
            <TextField
              floatingLabelText="Tax Rate"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.taxrate.tax || ''}
              name="tax"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.tax}
              errorStyle={{ color: cyan500 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

TaxrateNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

TaxrateNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    taxrate: state.taxrates.taxrate,
    error: state.taxrates.error,
  };
}

export default withRouter(connect(mapStateToProps)(TaxrateNewPage));



// WEBPACK FOOTER //
// ./src/containers/TaxrateNewPage.js